import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import SupplierRateServices from "../../../services/SupplierRateServices";

const RateMaster = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [status, setStatus] = useState("Active");
  const [rows, setRows] = useState(10);
  const [search, setSearch] = useState("");

  const activePag = useRef(0);

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Expired", label: "Expired" },
  ];

  const rowOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  // ================= FETCH =================
  useEffect(() => {
    setLoading(true);

    SupplierRateServices.getAllSupplierRatesByStatus(status)
      .then(res => {
        const list = res?.data || [];

        // ✅ ERP style sort by part no
        const sorted = [...list].sort((a, b) =>
          a.partNo.localeCompare(b.partNo)
        );

        setData(sorted);
        setFilteredData(sorted);
        activePag.current = 0;
        setLoading(false);
      })
      .catch(() => setLoading(false));

  }, [status]);

  // ================= SEARCH =================
  useEffect(() => {
    const q = search.toLowerCase();

    const filtered = data.filter(item =>
      item.partNo?.toLowerCase().includes(q) ||
      item.supplierId?.name?.toLowerCase().includes(q) ||
      item.description?.toLowerCase().includes(q)
    );

    setFilteredData(filtered);
    activePag.current = 0;

  }, [search, data]);

  // ================= PAGINATION =================
  const pagination = Math.ceil(filteredData.length / rows);

  const paginatedData = filteredData.slice(
    activePag.current * rows,
    (activePag.current + 1) * rows
  );

  const onClick = (i) => {
    activePag.current = i;
  };

  const formatDate = d => {
    if (!d) return "-";
    const x = new Date(d);
    return `${String(x.getDate()).padStart(2, "0")}/${String(x.getMonth() + 1).padStart(2, "0")}/${x.getFullYear()} ${String(x.getHours()).padStart(2, "0")}:${String(x.getMinutes()).padStart(2, "0")}:${String(x.getSeconds()).padStart(2, "0")}`;
  };

  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "300px" }}>
        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} />
        <p className="mt-3 text-primary fw-semibold">Rate Master Loading...</p>
      </div>
    );
  }

  let lastPart = null;

  return (
    <>
      <div className="row">
        <div className="col-xl-12">

          {/* FILTER */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fas fa-filter me-2" />Filter</div>
              <div className="tools">
                <Link to="#" onClick={() => setOpen(!open)}>
                  <i className="fas fa-angle-up" />
                </Link>
              </div>
            </div>

            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body row">

                  <div className="col-xl-4">
                    <Select
                      options={statusOptions}
                      value={statusOptions.find(s => s.value === status)}
                      onChange={e => setStatus(e.value)}
                      className="custom-react-select"
                      isSearchable={false}
                    />
                  </div>

                  <div className="col-xl-4">
                    <input
                      className="form-control"
                      placeholder="Search by Part No, Supplier, Description"
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />
                  </div>

                  <div className="col-xl-4">
                    <Select
                      options={rowOptions}
                      value={rowOptions.find(o => o.value === rows)}
                      onChange={e => {
                        setRows(e.value);
                        activePag.current = 0;
                      }}
                      className="custom-react-select"
                      isSearchable={false}
                    />
                  </div>

                </div>
              </div>
            </Collapse>
          </div>

          {/* TABLE */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                Supplier Rate Master
                <span className="badge bg-orange ms-2">{filteredData.length}</span>
              </div>
            </div>

            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">

                  <div style={{ overflow: "auto", maxHeight: "400px" }}>
                    <table className="table table-bordered table-striped">

                      <thead style={{ position: "sticky", top: 0, background: "#fff" }}>
                        <tr>
                          <th>S.No</th>
                          <th>Part No</th>
                          <th>Supplier</th>
                          <th>Unit</th>
                          <th>Rate</th>
                          <th>Valid From</th>
                          <th>Valid To</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
  {paginatedData.length ? (() => {
    let lastPartNo = null;

    return paginatedData.map((item, i) => {
      const showHeader = item.partNo !== lastPartNo;
      lastPartNo = item.partNo;

      return (
        <React.Fragment key={item._id}>
          
          {showHeader && (
            <tr style={{ background: "#f8f9fa", fontWeight: "600" }}>
              <td colSpan="8">
                ──── Part No: {item.partNo} ────
              </td>
            </tr>
          )}

          <tr>
            <td>{activePag.current * rows + i + 1}</td>
            <td>{item.partNo}</td>
            <td>{item.supplierId?.name}</td>
            <td>{item.unit}</td>
            <td>₹ {item.rate}</td>
            <td>{formatDate(item.validFrom)}</td>
            <td>
              {item.validTo ? formatDate(item.validTo) : "—"}
            </td>
            <td>
              <span
                className={`badge ${
                  item.status === "Active"
                    ? "bg-success"
                    : "bg-danger"
                }`}
              >
                {item.status}
              </span>
            </td>
          </tr>

        </React.Fragment>
      );
    });
  })() : (
    <tr>
      <td colSpan="8" className="text-center text-muted">
        No records found
      </td>
    </tr>
  )}
</tbody>

                    </table>
                  </div>

                  {/* PAGINATION */}
                  <div className="d-sm-flex justify-content-between mt-3">

                    <div>
                      Showing {activePag.current * rows + 1} to{" "}
                      {Math.min(filteredData.length, (activePag.current + 1) * rows)} of{" "}
                      {filteredData.length}
                    </div>

                    <div>
                      <Link onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                        <i className="fa fa-angle-double-left" />
                      </Link>

                      {Array.from({ length: pagination }, (_, i) => (
                        <Link
                          key={i}
                          className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                          onClick={() => onClick(i)}
                        >
                          {i + 1}
                        </Link>
                      ))}

                      <Link onClick={() => activePag.current + 1 < pagination && onClick(activePag.current + 1)}>
                        <i className="fa fa-angle-double-right" />
                      </Link>
                    </div>

                  </div>

                </div>
              </div>
            </Collapse>
          </div>

        </div>
      </div>
    </>
  );
};

export default RateMaster;